import { createPortal } from "react-dom";

const renderContainer = document.getElementById("modal-root");

export const ModalPortal = ({ children }) =>
  createPortal(children, renderContainer);
